import { useT } from "@/i18n";
import {
  IconArrowDown,
  IconArrowTop,
  IconStar,
  IconUnstar,
  NavLink as SharedNavLink,
  NavLinkProps as SharedNavLinkProps,
} from "@/ui";

export type BaseNavLinkAction = {
  type: "moveUp" | "moveDown" | "addToFavorites" | "removeFromFavorites";
  disabled?: boolean;
  hidden?: boolean;
  onClick: () => void;
};

export type BaseNavLinkProps = Omit<SharedNavLinkProps, "actions"> & {
  actions: BaseNavLinkAction[];
};

export const BaseNavLink = ({ actions: actionsProp, ...props }: BaseNavLinkProps) => {
  const t = useT();

  const actions = actionsProp
    .filter((action) => !action.hidden && !action.disabled)
    .map((action) => {
      switch (action.type) {
        case "moveUp":
          return {
            startIcon: IconArrowTop,
            label: t("general.navigation.actions.moveUp"),
            onAction: action.onClick,
          };
        case "moveDown":
          return {
            startIcon: IconArrowDown,
            label: t("general.navigation.actions.moveDown"),
            onAction: action.onClick,
          };
        case "addToFavorites":
          return {
            startIcon: IconStar,
            label: t("general.navigation.actions.addFavorite"),
            onAction: action.onClick,
          };
        case "removeFromFavorites":
          return {
            startIcon: IconUnstar,
            label: t("general.navigation.actions.removeFavorite"),
            onAction: action.onClick,
          };
      }
    });

  return <SharedNavLink actions={actions} {...props} />;
};
